import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import { tracking } from "shared/data";
import { PageType } from "shared/lib/page-type";

import type { bigReadQuery$key } from "scmp-app/queries/__generated__/bigReadQuery.graphql";

import { BigReadBackground } from "./big-read-background";
import { BigReadContent } from "./big-read-content";
import { Container, StyledHeadline } from "./styles";

type Props = {
  reference: bigReadQuery$key;
};

export const BigRead: FunctionComponent<Props> = ({ reference: reference_ }) => {
  const data = useFragment(
    graphql`
      fragment bigReadQuery on Query {
        bigReadSection: section(filter: { entityId: "515471" }) {
          ...headlineSection
        }
        bigReadQueue: queue(filter: { name: "section_top_515471" }) {
          ...bigReadContentQueue
        }
      }
    `,
    reference_,
  );

  const customQueryParameters = {
    module: tracking.module.BigRead,
    pgtype: tracking.pageType.Content,
  };

  return (
    <Container>
      <StyledHeadline
        color="#389810"
        query={{ pageType: PageType.PostiesSection, ...customQueryParameters }}
        reference={data.bigReadSection}
      />
      <BigReadBackground />
      {data.bigReadQueue && (
        <BigReadContent
          customQueryParameters={{ pageType: PageType.PostiesArticle, ...customQueryParameters }}
          reference={data.bigReadQueue}
        />
      )}
    </Container>
  );
};

BigRead.displayName = "BigRead";
